module.exports = __webpack_public_path__ + "img/icon-loader-lets1.b20e9c1a.svg";